<template>
    <section class="yellow-background relative">
        <div class="container section-small">
            <h2>Conference programme</h2>
        </div>
        <div class="programme-divider">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
            </svg>
        </div> 
    </section>

  <div class="container">

    <h1>Session</h1>
    <p>{{ route.params.id }}</p>
  </div>
</template>

<script setup>

  import axios from "axios"
  import { useRoute } from "vue-router"
  import { ref } from "vue"
  
  const route = useRoute()
  const sessionDetails = ref([])
  
  const getSession = async () => {
    const response = await axios.get(`https://www.utaresources.mmu.ac.uk/leed-conference-23/server/public/api/session/${route.params.id}`)
    sessionDetails.value = response.data;
    console.log( sessionDetails.value )
  }

  getSession()

</script>
